/**
 * Class representing an Ichimill device.
 */
class IchimillDevice {
    /**
     * Create an ichimill device.
     * @param {Object} data - Device data
     * @param {string} data.id - Device ID
     * @param {string} data.name - Device name
     * @param {Array} data.coord - Device coordinates in [longitude, latitude] format
     * @param {number} data.bearing - Device bearing in degrees
     * @param {number} [data.altitude=0] - Device altitude in meters
     */
    constructor({id, name, coord, bearing, altitude = 0, updatedAt = null}) {
        const me = this;

        me.id = id;
        me.name = name;
        me.coord = coord;
        me.bearing = bearing;
        me.altitude = altitude;
        me.updatedAt = updatedAt; // 更新日時
        me.color = '#ff9800'; // Ichimill orange color
        me.type = 'ichimill-device';
        me.outline = 0.5;
    }

    /**
     * デバイス情報を更新する
     * @param {Object} data - 更新データ
     */
    update(data) {
        const me = this;
        
        if (data.coord) me.coord = data.coord;
        if (data.bearing !== undefined) me.bearing = data.bearing;
        if (data.altitude !== undefined) me.altitude = data.altitude;
        if (data.name) me.name = data.name;
        if (data.updatedAt !== undefined) me.updatedAt = data.updatedAt;
    }

    /**
     * 画像データURL取得（ichimillには画像データなし）
     * @returns {string|null} 常にnull
     */
    getImageDataUrl() {
        return null; // ichimillには画像データがない
    }
}

export default IchimillDevice;